<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    plotTitle: {
      type: String,
      default: '',
    },
    imageSource: {
      type: String,
      default: '',
    },
  },
}
</script>
